import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7d2a00b3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "kline-head"
};
const _hoisted_2 = {
  class: "content title kline-title"
};
const _hoisted_3 = {
  class: "divider-example-vertical-container"
};
const _hoisted_4 = {
  class: "m-titleRt"
};
const _hoisted_5 = {
  class: "m-checkList",
  style: {
    "opacity": "1"
  }
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "主队", -1));
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  class: "divider-example-vertical-container"
};
import { ref } from 'vue';
import axios from 'axios';
import KLineTrendView from './KLineTrendView.vue';
import { lastHours, resolvePan, buildCandle, renderKline } from './klineBuilder.js';
export default {
  __name: 'KLineView',
  setup(__props, {
    expose: __expose
  }) {
    const COMPANY_NAMES = ['皇冠', '365', '澳门', '威廉希尔', '香港马会'];
    const chartContainer1 = ref(null);
    const chartContainer2 = ref(null);
    const divStyle1 = ref('display: none;'); // 初始样式设置div为可见
    const divStyle2 = ref('display: none;'); // 初始样式设置div为可见
    const isVisible = ref(false);
    const active = ref(1);
    const oddId = ref("");
    const title = ref('');
    const goalLine = ref("");
    const footBall = ref({
      host: '',
      handicap: "",
      guest: "",
      big: "",
      dw_HANDICAP: "",
      small: ""
    });
    const isActive1 = ref(true);
    const isActive2 = ref(false);
    const cId = ref('2');
    const type1 = ref(null);
    const status1 = ref(null);
    const matchId1 = ref(null);
    const kLineTrendRef = ref(null); // 全屏横屏 K 线层
    const fullAsianRows = ref([]); // 原始(未切窗口)亚盘变动点
    const fullSizeRows = ref([]); // 原始(未切窗口)大小盘变动点
    const show = async (id, matchId) => {
      isVisible.value = true;
      oddId.value = id;
      active.value = 1;
      matchId1.value = matchId;
      await getFixedBonusV1(matchId);
      await getKLineList(id, "2", null, null, matchId);
    };
    // 关闭弹出框
    const close = () => {
      isVisible.value = false;
    };
    const getFixedBonusV1 = async matchId => {
      const response = await axios.get('https://webapi.sporttery.cn/gateway/uniform/football/getFixedBonusV1.qry?clientCode=3001&matchId=' + matchId);
      let data = response.data;
      if (data.success) {
        let oddsHistory = data.value.oddsHistory;
        title.value = oddsHistory.homeTeamAbbName + ' VS ' + oddsHistory.awayTeamAbbName;
        goalLine.value = oddsHistory.hhadList[0].goalLine;
        if (data.value.sectionsNo999 != '') {
          title.value = oddsHistory.homeTeamAbbName + ' ' + data.value.sectionsNo999 + ' ' + oddsHistory.awayTeamAbbName;
        }
      }
    };
    const change = value => {
      let company = 3;
      if (value == 0) {
        company = 3;
      } else if (value == 1) {
        company = 2;
      } else if (value == 2) {
        company = 7;
      } else if (value == 3) {
        company = 9;
      } else if (value == 4) {
        company = 136;
      } else {
        company = 2;
      }
      divStyle1.value = 'display: none';
      divStyle2.value = 'display: none';
      footBall.value = {
        host: '',
        handicap: "",
        guest: "",
        big: "",
        dw_HANDICAP: "",
        small: ""
      };
      getKLineList(oddId.value, company, type1.value, status1.value, matchId1.value);
    };
    const getKLineList = async (id, companyId, type, status, matchId) => {
      const response = await axios.get('https://tuhaojie.asia/api-foot/matchGoalWater/getKLineList?id=' + matchId + '&company=' + companyId);
      let list = response.data;
      // 暂存原始变动点（未切窗口），供全屏 6 小时视图使用
      fullAsianRows.value = list && list.list1 || [];
      fullSizeRows.value = list && list.list2 || [];
      isActive1.value = true;
      isActive2.value = false;
      cId.value = companyId;
      type1.value = type;
      status1.value = status;
      footBallRate1(list && list.list1, type);
      footBallRate2(list && list.list2);
    };

    // 打开全屏横屏 K 线（固定当前公司/主客侧，展示近 6 小时）
    const openKLineFull = () => {
      if (!fullAsianRows.value.length && !fullSizeRows.value.length) {
        return;
      }
      kLineTrendRef.value.show({
        head: (goalLine.value ? '(' + goalLine.value + ')' : '') + title.value,
        company: COMPANY_NAMES[active.value] || '',
        asianRows: lastHours(fullAsianRows.value, 6),
        sizeRows: lastHours(fullSizeRows.value, 6),
        pan: type1.value
      });
    };
    const footBallRate1 = (data, type) => {
      try {
        const rows = lastHours(data, 3); // 默认竖屏只展示近 3 小时
        if (rows.length > 0) {
          footBall.value = rows[rows.length - 1];
        }
        if (rows.length > 0 && rows[rows.length - 1].handicap != null) {
          divStyle1.value = 'display: block';
          if (chartContainer1.value) chartContainer1.value.style.display = 'block';
          const pan = resolvePan(rows, type);
          isActive1.value = pan <= 0;
          isActive2.value = pan > 0;
          const b = buildCandle(rows, 'asian', pan);
          renderKline(chartContainer1.value, b.xData, b.sData, b.lineList, b.metas, 'asian', false);
        }
      } catch (error) {
        // 处理错误
        console.error(error);
      }
    };
    const footBallRate2 = data => {
      try {
        const rows = lastHours(data, 3); // 默认竖屏只展示近 3 小时
        if (rows.length > 0 && rows[rows.length - 1].big != null) {
          divStyle2.value = 'display: block';
          if (chartContainer2.value) chartContainer2.value.style.display = 'block';
          const b = buildCandle(rows, 'size');
          renderKline(chartContainer2.value, b.xData, b.sData, b.lineList, b.metas, 'size', false);
        }
      } catch (error) {
        // 处理错误
        console.error(error);
      }
    };

    // 暴露给外部使用的函数
    // eslint-disable-next-line no-undef
    __expose({
      show,
      close
    });
    return (_ctx, _cache) => {
      const _component_nut_col = _resolveComponent("nut-col");
      const _component_nut_row = _resolveComponent("nut-row");
      const _component_var_tab = _resolveComponent("var-tab");
      const _component_var_tabs = _resolveComponent("var-tabs");
      const _component_nut_divider = _resolveComponent("nut-divider");
      const _component_var_divider = _resolveComponent("var-divider");
      const _component_nut_popup = _resolveComponent("nut-popup");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_nut_popup, {
        visible: isVisible.value,
        "onUpdate:visible": _cache[3] || (_cache[3] = $event => isVisible.value = $event),
        closeable: "",
        style: {
          padding: '30px 0px',
          height: '85%',
          width: '90%',
          overflow: 'auto'
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_nut_row, null, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, "(" + _toDisplayString(goalLine.value) + ")" + _toDisplayString(title.value), 1), _createElementVNode("div", {
              class: "kline-full-btn",
              onClick: openKLineFull
            }, "⛶ 全屏K线")])]),
            _: 1
          })]),
          _: 1
        })]), _createVNode(_component_var_tabs, {
          active: active.value,
          "onUpdate:active": _cache[0] || (_cache[0] = $event => active.value = $event),
          onChange: change
        }, {
          default: _withCtx(() => [_createVNode(_component_var_tab, null, {
            default: _withCtx(() => [_createTextVNode("皇冠")]),
            _: 1
          }), _createVNode(_component_var_tab, null, {
            default: _withCtx(() => [_createTextVNode("365")]),
            _: 1
          }), _createVNode(_component_var_tab, null, {
            default: _withCtx(() => [_createTextVNode("澳门")]),
            _: 1
          }), _createVNode(_component_var_tab, null, {
            default: _withCtx(() => [_createTextVNode("威廉希尔")]),
            _: 1
          }), _createVNode(_component_var_tab, null, {
            default: _withCtx(() => [_createTextVNode("香港马会")]),
            _: 1
          })]),
          _: 1
        }, 8, ["active"]), _createVNode(_component_nut_divider, {
          "content-position": "left",
          style: {
            margin: '5px 0'
          }
        }, {
          default: _withCtx(() => [_createTextVNode("亚盘K线")]),
          _: 1
        }), _createElementVNode("div", null, [_createVNode(_component_nut_row, null, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(footBall.value?.host), 1), _createVNode(_component_var_divider, {
              vertical: ""
            }), _createElementVNode("span", null, _toDisplayString(footBall.value?.handicap), 1), _createVNode(_component_var_divider, {
              vertical: ""
            }), _createElementVNode("span", null, _toDisplayString(footBall.value?.guest), 1)])]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
              class: _normalizeClass(["u-check", {
                active: isActive1.value
              }]),
              onClick: _cache[1] || (_cache[1] = $event => getKLineList(oddId.value, cId.value, -1, status1.value, matchId1.value))
            }, _hoisted_7, 2), _createElementVNode("div", {
              class: _normalizeClass(["u-check", {
                active: isActive2.value
              }]),
              onClick: _cache[2] || (_cache[2] = $event => getKLineList(oddId.value, cId.value, 1, status1.value, matchId1.value))
            }, "客队", 2)])])]),
            _: 1
          })]),
          _: 1
        })]), _createElementVNode("div", {
          ref_key: "chartContainer1",
          ref: chartContainer1,
          style: _normalizeStyle([{
            "width": "90vw",
            "height": "300px"
          }, divStyle1.value])
        }, null, 4), _createVNode(_component_nut_divider, {
          "content-position": "left"
        }, {
          default: _withCtx(() => [_createTextVNode("大小盘K线")]),
          _: 1
        }), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(footBall.value.big), 1), _createVNode(_component_var_divider, {
          vertical: ""
        }), _createElementVNode("span", null, _toDisplayString(footBall.value.dw_HANDICAP), 1), _createVNode(_component_var_divider, {
          vertical: ""
        }), _createElementVNode("span", null, _toDisplayString(footBall.value.small), 1)]), _createElementVNode("div", {
          ref_key: "chartContainer2",
          ref: chartContainer2,
          style: _normalizeStyle([{
            "width": "90vw",
            "height": "300px"
          }, divStyle2.value])
        }, null, 4)]),
        _: 1
      }, 8, ["visible"]), _createVNode(KLineTrendView, {
        ref_key: "kLineTrendRef",
        ref: kLineTrendRef
      }, null, 512)], 64);
    };
  }
};